module.exports = __webpack_public_path__ + "img/kh21.fdfbf471.png";